<po-modal #editModal [p-title]="'Editar ' + (user?.username || '')" p-size="lg" [p-primary-action]="savePrimary" [p-secondary-action]="saveCancel">
  <ng-container *ngIf="user">
    <div class="po-row">
      <po-combo
        class="po-sm-12 po-md-8"
        name="editArea"
        p-label="Área"
        p-placeholder="Sem área (digite para buscar)"
        p-field-label="label"
        p-field-value="value"
        p-clean
        [p-filter-service]="areaCombo"
        [ngModel]="areaId"
        (ngModelChange)="onAreaChange($event)"
        [p-disabled]="saving"
      >
        <ng-template p-combo-option-template let-option>
          <span>{{ option.label }}</span>
          <span class="user-edit-area-tribe">{{ option.tribeName }}</span>
        </ng-template>
      </po-combo>
      <po-input
        class="po-sm-12 po-md-4"
        name="editTribe"
        p-label="Tribe"
        p-disabled="true"
        [ngModel]="areaId ? tribeName || 'Sem tribe' : ''"
      ></po-input>
    </div>

    <po-divider p-label="Acessos"></po-divider>

    <div class="po-row">
      <po-checkbox-group
        *ngFor="let g of groups; trackBy: trackGroup"
        class="po-sm-12 po-md-4"
        [name]="'editRoles-' + g.group"
        [p-label]="g.label"
        [p-columns]="1"
        [p-options]="g.options"
        [ngModel]="g.selected"
        (ngModelChange)="onGroupRolesChange(g.group, $event)"
        [p-disabled]="saving"
      ></po-checkbox-group>
    </div>
  </ng-container>
</po-modal>

<po-modal #historyModal [p-title]="'Histórico de ' + (user?.username || '')" p-size="lg">
  <po-table
    [p-items]="history"
    [p-columns]="historyColumns"
    [p-loading]="loadingHistory"
    p-hide-columns-manager="true"
    p-striped="true"
    p-spacing="small"
    [p-literals]="{ noData: 'Nenhuma alteração registrada' }"
  >
    <ng-template p-table-cell-template let-column="column" let-row="row">
      <po-tag *ngIf="column.property === 'action'" [p-value]="row.action.label" [p-color]="row.action.color" [p-text-color]="row.action.textColor"></po-tag>
      <ng-container *ngIf="column.property === 'details'">
        <div *ngIf="row.roles.length; else detailsText" class="audit-roles">
          <span *ngFor="let r of row.roles" [title]="r.key"><po-tag [p-value]="r.label" [p-color]="r.color" [p-text-color]="r.textColor"></po-tag></span>
        </div>
        <ng-template #detailsText>{{ row.details }}</ng-template>
      </ng-container>
    </ng-template>
  </po-table>
</po-modal>
